import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import useNebula from 'hooks/useNebula';
import useQlikApp from 'hooks/useQlikApp';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  viz: {
    height: 250,
    '& > div': {
      backgroundColor: 'transparent',
      overflow: 'visible !important',
    },
    '& svg': {
      overflow: 'visible !important',
      '& text': {
        writingMode: 'vertical-rl !important',
        textAnchor: 'end !important',
      },
    },
  },
}));

const Waffle = ({ mix, color }) => {
  const nebula = useNebula();
  const elementRef = useRef();
  const vizRef = useRef();
  const app = useQlikApp();

  useEffect(async () => {
    if (!nebula) return;

    vizRef.current = await nebula.render({
      element: elementRef.current,
      type: 'waffle',
      fields: [
        {
          qDef: {
            qFieldDefs: ['Race'],
          },
        },
        {
          qDef: {
            qFieldDefs: ['Race'],
          },
        },
        {
          qDef: {
            qDef: '=Sum({<[Name of media outlet completing the survey]=, [Name of media outlet for search]=, [Race]=-{Unknown}>} [Number of Employees])',
          },
        },
      ],
    });
  }, [nebula]);

  // Change based on selects
  useEffect(async () => {
    if (!app) return;
    const appObj = await app.getObject(vizRef.current.id);

    // const measure = mix === 'Race'
    //   ? '=Sum({<[Name of media outlet completing the survey]=, [Name of media outlet for search]=, [Race]=-{Unknown}>} [Number of Employees])'
    //   : '=Sum({<[Name of media outlet completing the survey]=, [Name of media outlet for search]=>} [Number of Employees])';
    // const measure = '=Sum({<[Name of media outlet completing the survey]=, [Name of media outlet for search]=>} [Number of Employees])';
    await appObj.applyPatches([
      {
        qPath: '/qHyperCubeDef/qDimensions/0/qDef/qFieldDefs/0',
        qOp: 'replace',
        qValue: JSON.stringify(`[${mix}]`),
      },
      {
        qPath: '/qHyperCubeDef/qDimensions/1/qDef/qFieldDefs/0',
        qOp: 'replace',
        qValue: JSON.stringify(`[${color}]`),
      },
      // {
      //   qPath: '/qHyperCubeDef/qMeasures/0/qDef/qDef',
      //   qOp: 'replace',
      //   qValue: JSON.stringify(`${measure}`),
      // },
    ], true);
  }, [mix, color]);

  const classes = useStyles();
  return (
    <>
      <div id="waffleViz" className={classes.viz} ref={elementRef} />
    </>
  );
};

Waffle.propTypes = {
  mix: PropTypes.string,
  color: PropTypes.string,
};

Waffle.defaultProps = {
  mix: 'Race',
  color: 'Race',
};

export default Waffle;
